import styled from 'styled-components';
import { Dropdown, size } from '@everlywell/leaves';

export const QtyDropdown = styled(Dropdown)`
  display: block;
  margin-right: ${size.lg}px;
`;
